export default __webpack_public_path__ + "static/media/loading.1db46d1f.png";